import React from 'react'
import * as yup from 'yup'

import { FormattedMessage } from '@divvy-web/i18n'

export const verifyCodeModalValidationSchema = yup.object().shape({
  code: yup.string().required(() => (
    <FormattedMessage
      defaultMessage='Please enter a valid access code'
      id='sputnik.verifyCodeModalValidationSchema__nizSRA'
    />
  )),
})

export type VerifyCodeModalValidationSchema = yup.InferType<typeof verifyCodeModalValidationSchema>
